
import React from "react";
const Modal_header = (props) => {


  return (
    <div className="modal-header">
    <button
      type="button"
      className="close"
      data-dismiss="modal"
      onClick={props.reset_modal}
      style={{
        backgroundColor: "white",
        color: "#2C40CE",
        fontSize: "30px",
      }}
    >
      &times;
    </button>
    <h4 className="modal-title">{`Add new ${
      props.isAction ? "Action" : props.isApp ? "Action" : "Trigger"
    }`}</h4>
  </div>
  );
};

export default Modal_header;
